import * as CountryFlags from 'country-flag-icons/string/3x2';

/**
 * ISO alpha-2 국가 코드에 해당하는 국기 SVG(문자열)를 반환한다.
 * 매핑에 없는 코드면 null을 반환하여, 국기 없이 텍스트만 표시되도록 한다.
 * @param {string} code ISO 3166-1 alpha-2 코드 (예: "KR")
 * @returns {string|null} 국기 SVG 문자열 또는 null
 */
export function getCountryFlagSvg(code) {
    const key = code?.toString().trim().toUpperCase();
    if (!key) return null;
    return CountryFlags[key] || null;
}

/**
 * 성별 비율을 정규화해 퍼센트로 변환한다. 비율 정보가 없으면 null.
 * @param {number} maleRatio
 * @param {number} femaleRatio
 * @returns {{malePercent: number, femalePercent: number, normalizedMaleRatio: number, normalizedFemaleRatio: number}|null}
 */
export function buildGenderRatio(maleRatio, femaleRatio) {
    const normalizedMaleRatio = Number(maleRatio);
    const normalizedFemaleRatio = Number(femaleRatio);
    const hasRatio =
        Number.isFinite(normalizedMaleRatio) &&
        Number.isFinite(normalizedFemaleRatio) &&
        normalizedMaleRatio + normalizedFemaleRatio > 0;

    if (!hasRatio) return null;

    const malePercent = Math.round(
        (normalizedMaleRatio / (normalizedMaleRatio + normalizedFemaleRatio)) * 100
    );

    return {
        malePercent,
        femalePercent: 100 - malePercent,
        normalizedMaleRatio,
        normalizedFemaleRatio,
    };
}

/**
 * 브랜드 위키에 표시할 정보가 하나라도 있는지 여부.
 * @param {object|null} metadata brand.brand_metadata
 * @returns {boolean}
 */
export function hasBrandWikiInfo(metadata) {
    if (!metadata) return false;
    return Boolean(
        metadata.country_iso_code ||
        metadata.city ||
        metadata.founded_at ||
        buildGenderRatio(metadata.male_ratio, metadata.female_ratio)
    );
}
